<div class="cms-page">
  <p-toast></p-toast>
  <span class="page-focus-trap" tabindex="-1" aria-hidden="true"></span>
  <div class="page-header">
    <div class="page-header__top">
      <h1 class="page-title">Products</h1>
      <p-button label="Add Product" icon="pi pi-plus" (onClick)="onAddProduct()" />
    </div>
    <div class="page-header__filters">
      <p-select-button
        [options]="labelOptions()"
        [ngModel]="displayedSelection()"
        (ngModelChange)="onLabelFilterChange($event)"
        optionLabel="label"
        optionValue="value"
        [multiple]="true"
        size="small"
      />
    </div>
  </div>
  <div
    class="page-body"
    cdkDropList
    cdkDropListOrientation="mixed"
    [cdkDropListData]="filteredProducts()"
    (cdkDropListDropped)="onDrop($event)"
  >
    @for (product of filteredProducts(); track product._cardId) {
      <div class="page-card-item" cdkDrag [cdkDragData]="product">
        <lib-cms-card
          [service]="product"
          (serviceChange)="onProductChange(product._cardId, $event)"
          (deleteService)="onDeleteProduct(product._cardId)"
        />
      </div>
    } @empty {
      <p class="page-empty">No products match the selected filters.</p>
    }
  </div>
  <div class="page-footer">
    <p-button label="Publish" [disabled]="hasInvalidCards()" (onClick)="onPublish()" />
  </div>
</div>
